import { trackClientEvent } from 'analytics/analytics'

const READ_MORE_TRACKING_MAP: Record<string, string> = {
  'getting-there': 'offer_page_read_more_location',
  highlights: 'offer_page_read_more_highlights',
  facilities: 'offer_page_read_more_facilities',
  'fine-print': 'offer_page_read_more_fine_print',
}

export function maybeTrackReadMoreClientEvent(id: string, isOpening: boolean) {
  if (READ_MORE_TRACKING_MAP[id]) {
    const subject = isOpening ? READ_MORE_TRACKING_MAP[id] : `${READ_MORE_TRACKING_MAP[id]}_close`
    trackClientEvent({
      subject,
      action: 'click',
      category: 'offer page',
      type: 'interaction',
    })
  }
}
